import { GetterTree } from "vuex";
import { RootState } from "@/models/states/RootState";

const getters: GetterTree<RootState, RootState> = {};
export default getters;
